import * as React from 'react';
import { useForm } from 'react-hook-form';
// import axios from 'axios';
import {
  // Alert,
  Heading,
  Select,
  TextField,
  Button,
  Row,
  Col,
  FormattedTextField,
} from '@elevationscu/ui-component-lib';
import styles from '../App.module.scss';
import ProgressBar from './ProgressBar';
import DataDisclaimer from './data-disclaimer';
import prospectPut from './helper-functions';

export default function Page2({
  pageNumber, userInfo, setUserInfo, nextPage, previousPage, maxPages,
}) {
  const {
    register, handleSubmit, clearErrors, formState: { errors, isValid },
  } = useForm({ mode: 'all' });

  const [address, setAddress] = React.useState('');
  const [city, setCity] = React.useState('');
  const [zipCode, setZipCode] = React.useState('');
  const [currentMortgageAmount, setCurrentMortgageAmount] = React.useState('');
  const [currentMortgageAmountError, setCurrentMortgageAmountError] = React.useState(false);
  const [estimatedPropertyPrice, setEstimatedPropertyPrice] = React.useState('');
  const [estimatedPropertyPriceError, setEstimatedPropertyPriceError] = React.useState(false);
  const [requestedLoanAmount, setRequestedLoanAmount] = React.useState('');
  const [requestedLoanAmountError, setRequestedLoanAmountError] = React.useState(false);
  const [occupancyType, setOccupancyType] = React.useState('Primary Home');

  const validationSchema = {
    address: {
      required: false,
    },
    city: {
      required: false,
    },
    zipCode: {
      required: false,
    },
    currentMortgageAmount: {
      required: true,
      message: 'Current mortgage amount must be 0 or greater',
      validate: {
        min: (v) => parseFloat(v) >= 0,
      },
    },
    estimatedPropertyPrice: {
      required: true,
      message: 'Property value must be greater than 0',
      validate: {
        min: (v) => parseFloat(v) > 0,
      },
    },
    requestedLoanAmount: {
      required: true,
      message: 'Loan amount must be greater than 0',
      validate: {
        min: (v) => parseFloat(v) > 0,
      },
    },
    occupancyType: {
      required: true,
      message: 'You must select an occupancy type',
      validate: (value) => value === 'Primary Home' || value === 'Second Home' || value === 'Investment Property',
    },
  };

  React.useEffect(() => {
    if (userInfo.application_data.address) setAddress(userInfo.application_data.address);
    if (userInfo.application_data.city) setCity(userInfo.application_data.city);
    if (userInfo.application_data.zipCode) setZipCode(userInfo.application_data.zipCode);
    if (userInfo.application_data.currentMortgageAmount) setCurrentMortgageAmount(userInfo.application_data.currentMortgageAmount);
    if (userInfo.application_data.estimatedPropertyPrice) setEstimatedPropertyPrice(userInfo.application_data.estimatedPropertyPrice);
    if (userInfo.application_data.requestedLoanAmount) setRequestedLoanAmount(userInfo.application_data.requestedLoanAmount);
    if (userInfo.application_data.occupancyType) setOccupancyType(userInfo.application_data.occupancyType);
    // eslint-disable-next-line
    }, [])

  async function next() {
    const tempUserInfo = {
      ...userInfo,
      application_data: {
        ...userInfo.application_data,
        address,
        city,
        zipCode,
        currentMortgageAmount,
        estimatedPropertyPrice,
        requestedLoanAmount,
        occupancyType,
      },
    };

    const response = await prospectPut(tempUserInfo);
    if (response === 400) {
      // console.log('error occured while updating information');
    //   setDuplicateEmailError("We're sorry for the inconvenience, but we're unable to process your request. Please call 800.460.2889 for immediate assistance.");
    //   return;
    }

    setUserInfo(tempUserInfo);
    nextPage(tempUserInfo);
  }

  function previous() {
    const tempUserInfo = {
      ...userInfo,
      application_data: {
        ...userInfo.application_data,
        address,
        city,
        zipCode,
        currentMortgageAmount,
        estimatedPropertyPrice,
        requestedLoanAmount,
        occupancyType,
      },
    };

    setUserInfo(tempUserInfo);
    previousPage(tempUserInfo);
  }

  React.useEffect(() => {
    clearErrors();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Row>
        <Col>
          <Heading size={2} element="h1" className={styles.dataFormHeader}>
            Let’s talk numbers.
          </Heading>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className={styles.inputRequest}>
            <span>
              Now let’s get into the details of your current situation. The more we know about your loan, the better we can serve you and get you better terms on your mortgage.
            </span>
            <br />
            <br />
            <span>
              Once we have this information we can help you decide if it’s time for a line of credit!
            </span>
          </div>
        </Col>
      </Row>
      <div className={styles.prospectInput}>
        <Row>
          <Col>
            <ProgressBar pageNumber={pageNumber} maxPages={maxPages} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Heading size={3} element="h2" className={styles.inputHeader}>
              Tell us about your property
            </Heading>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className={styles.dataFormSpan}>
              Having the address of your property allows us to make more accurate estimates that take into account location specific items such as property values, insurance and taxes.
            </div>
          </Col>
        </Row>
        <div className={styles.dataInputs}>
          <Row>
            <Col xs={12} lg={4}>
              <div className={styles.indivInput}>
                <TextField
                  type="text"
                  label="Address (optional)"
                  id="inputAddress"
                  value={address}
                  error={errors.address && validationSchema.address.message}
                  {...register('address', { required: false, onChange: (e) => { setAddress(e.target.value); } })}
                />
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className={styles.indivInput}>
                <TextField
                  type="text"
                  label="City (optional)"
                  id="inputCity"
                  value={city}
                  error={errors.city && validationSchema.city.message}
                  {...register('city', { required: false, onChange: (e) => setCity(e.target.value) })}
                />
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className={styles.indivInput}>
                <TextField
                  type="text"
                  label="Zip code (optional)"
                  id="inputZipCode"
                  value={zipCode}
                  error={errors.zipCode && validationSchema.zipCode.message}
                  {...register('zipCode', {
                    required: false,
                    onChange: (e) => { setZipCode(e.target.value.replace(/\D/g, '')); },
                  })}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={4}>
              <div className={styles.indivInput}>
                <FormattedTextField
                  format="dollars"
                  label="Current mortgage amount (required)"
                  id="inputCurrentMortgageAmount"
                  value={currentMortgageAmount}
                  key={currentMortgageAmount}
                  error={currentMortgageAmountError && validationSchema.currentMortgageAmount.message}
                  onBlur={(e) => {
                    if (e.target.value <= 0 || e.target.value === '') {
                      setCurrentMortgageAmountError(true);
                    } else {
                      setCurrentMortgageAmountError(false);
                    }
                    setCurrentMortgageAmount(e.target.value);
                  }}
                />
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className={styles.indivInput}>
                <FormattedTextField
                  format="dollars"
                  label="Estimated property value (required)"
                  id="inputEstimatedPropertyPrice"
                  value={estimatedPropertyPrice}
                  key={estimatedPropertyPrice}
                  error={estimatedPropertyPriceError && validationSchema.estimatedPropertyPrice.message}
                  onBlur={(e) => {
                    if (Number(e.target.value) <= 0 || e.target.value === '') {
                      setEstimatedPropertyPriceError(true);
                    } else {
                      setEstimatedPropertyPriceError(false);
                    }
                    setEstimatedPropertyPrice(e.target.value);
                  }}
                />
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className={styles.indivInput}>
                <FormattedTextField
                  format="dollars"
                  label="Requested loan amount (required)"
                  id="inputRequestedLoanAmount"
                  value={requestedLoanAmount}
                  key={requestedLoanAmount}
                  error={requestedLoanAmountError && validationSchema.requestedLoanAmount.message}
                  onBlur={(e) => {
                    if (Number(e.target.value) <= 0 || e.target.value === '') {
                      setRequestedLoanAmountError(true);
                    } else {
                      setRequestedLoanAmountError(false);
                    }
                    setRequestedLoanAmount(e.target.value);
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={4}>
              <div className={styles.indivInput}>
                <Select
                  name="occupancyType"
                  id="occupancyType"
                  defaultValue={occupancyType}
                  label="Occupancy type (required)"
                  value={occupancyType}
                  error={errors.occupancyType && validationSchema.occupancyType.message}
                  {...register('occupancyType', { ...validationSchema.occupancyType, onChange: (e) => { setOccupancyType(e.target.value); } })}
                >
                  <option value="Primary Home">Primary Home</option>
                  <option value="Second Home">Second Home</option>
                  <option value="Investment Property">Investment Property</option>
                </Select>
              </div>
            </Col>
          </Row>
        </div>
        <div className={styles.loanOfficerOptions}>
          <Row>
            <Col lg={8}>
              <DataDisclaimer firstPage />
            </Col>
            {/* {duplicateEmailError
                            && (
                            <div>
                              <Alert variant="error">
                                {duplicateEmailError}
                              </Alert>
                            </div>
                            )} */}

            <Col xs={6} md={6} lg={2} className={styles.previousButtonCol}>
              <button onClick={previous} className={styles.previousButton} id="btn_previous" type="button">
                Previous
              </button>
            </Col>
            <Col xs={6} md={6} lg={2} className={styles.nextOrSubmitButtonCol}>
              <div className={styles.nextButton}>
                <Button
                  disabled={!isValid
                    || (currentMortgageAmountError || (currentMortgageAmount === ''))
                    || (estimatedPropertyPriceError || (estimatedPropertyPrice === ''))
                    || (requestedLoanAmountError || (requestedLoanAmount === ''))}
                  onClick={handleSubmit(() => {
                    next();
                  })}
                  id="dataNextButton"
                >
                  Next
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
